// src/Api/services/clientService.ts

import {
  GetByIdUserRenseponse,
  GetUsersRenseponse,
} from "../../Types/UserManagement";
import api from "../axios";

import { ENDPOINTS } from "../endpoints";

export const userService = {
  getUserById: (id: string) =>
    api.get<GetByIdUserRenseponse>(`${ENDPOINTS.USER}${id}`),
  getUsers: () => api.get<GetUsersRenseponse>(`${ENDPOINTS.USER}`),
  deleteUser: (id: string) =>
    api.delete<GetByIdUserRenseponse>(`${ENDPOINTS.USER}${id}`),
};
